import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getErrorIssues = async (query = {}) => {
  const response = await request(getEndpoint("errors", "getErrorIssues"), {
    query,
  });
  return {
    records: response.data || [],
    pagination: response.pagination || {},
  };
};

export const getErrorIssue = async (issueId) => {
  const response = await request(getEndpoint("errors", "getErrorIssue", issueId));
  return response.data;
};

export const updateErrorIssueStatus = async (issueId, status) => {
  const response = await request(
    getEndpoint("errors", "updateErrorIssueStatus", issueId),
    { body: { status } },
  );
  return response.data;
};

export const getErrorEvents = async (query = {}) => {
  const response = await request(getEndpoint("errors", "getErrorEvents"), {
    query,
  });
  return {
    records: response.data || [],
    pagination: response.pagination || {},
  };
};

export const getErrorEvent = async (eventId) => {
  const response = await request(getEndpoint("errors", "getErrorEvent", eventId));
  return response.data;
};

export const updateErrorEventStatus = async (eventId, status) => {
  const response = await request(
    getEndpoint("errors", "updateErrorEventStatus", eventId),
    { body: { status } },
  );
  return response.data;
};
